"use client";
import GameCardDetailed from '@/components/game/card/detailed';
import LatestInjuries from '@/components/global/latest-injuries';
import TopPickers from '@/components/global/top-pickers';
import TopSportsbooks from '@/components/global/top-sportsbooks';
import Card from '@/components/primitives/card';
import { GameProvider } from '@/utils/providers/game';
import { ScoreboardGame, Sport, TeamBasic, TeamColor } from 'common';
import React from 'react';

export interface TeamSidebarProps {
  sport: Sport;
    team: TeamBasic & TeamColor;
    nextGame?: ScoreboardGame,
    lastGame?: ScoreboardGame,
  }
  export default function TeamLayoutSidebar(props: TeamSidebarProps) {

      // const wsGames = useWebSocketMessage("scoreboard");
  // const [data, setData] = React.useState<ScoreboardGame[]>(props.nextGame && props.lastGame ? [props.nextGame, props.lastGame] : props.nextGame ? [props.nextGame] : props.lastGame ? [props.lastGame] : []);
// useScoreboardUpdate([data], setData, undefined);
  
    // React.useEffect(() => {
    //     if (!Array.isArray(wsGames) || !data) return;
    
    //     const update = wsGames.find((wsGame) => wsGame.id === data.id);
    //     if (update) {
    //       const newData = {
    //         ...data,
    //         ...update,
    //         odds: {
    //           ...data.odds,
    //           ...(update.odds && update.odds),
    //         },
    //         awayTeam: {
    //           ...data.awayTeam,
    //           ...(update.awayTeam && update.awayTeam),
    //         },
    //         homeTeam: {
    //           ...data.homeTeam,
    //           ...(update.homeTeam && update.homeTeam),
    //         },
    //         awayRecord: {
    //           ...data.awayRecord,
    //           ...(update.awayRecord && update.awayRecord),
    //         },
    //         homeRecord: {
    //           ...data.homeRecord,
    //           ...(update.homeRecord && update.homeRecord),
    //         },
    //         status: update.status || data.status,
    //         period: update.period || data.period,
    //       };
    //       setData(newData);
    //     }
    //   }, [wsGames]);
    return (
      <Card.Group>
        <>
          {props.nextGame && (
            <GameProvider game={props.nextGame}>
              <GameCardDetailed index={0} next={true} teamColor={props.team.primaryColor} />
            </GameProvider>
          )}
          {props.lastGame && (
            <GameProvider game={props.lastGame}>
              <GameCardDetailed index={0} next={false} teamColor={props.team.primaryColor} />
            </GameProvider>
          )}
        </>
        <TopPickers sport={props.sport} team={props.team} />
        <LatestInjuries sport={props.sport} team={props.team} />
        <TopSportsbooks />
      </Card.Group>
    );
  }
  
